<template>
	<el-row id="menu-detail-price">
		<el-col :span="15" class="text-left">
			<Skeleton 
				:loading="!subtotal && loading" 
				animated
			>
			 	<template #loading>
					<SkeletonItem variant="heading3" style="width: 45%; height: 26px;" />
        </template>
				<template>
					<label class="fs-al-md price-tag">
						<em class="fs-st-n cl-gray-ligth">{{ $t('pageMenuDetail.price') }}</em> 
						<span :class="{ 'fs-link': activeTotalPrice }">{{ subtotal | priceFormat(0,currency) }}</span>
					</label>
				</template>
			</Skeleton>
		</el-col>
		<el-col :span="9" class="fs-count text-button">
			<el-row class="input-number ">
				<el-col :span="8" @click.native="DecreaseToCart" class="btn text-center">
					<i class="fas fa-minus" style="vertical-align: middle;"></i>
				</el-col>
				<el-col :span="8" class="btn text-center">
					{{ num }}
				</el-col>
				<el-col :span="8" @click.native="IncreaseToCart" class="btn text-center">
					<i class="fas fa-plus" style="vertical-align: middle;"></i>
				</el-col>
			</el-row>
		</el-col>
	</el-row>
</template>
<script>
// import AnimatedNumber from "animated-number-vue";
import Mixins from '@/utils/mixins'

export default {
	props: ['menudetail', 'options', 'notaion' , 'flag', 'loading'],
	mixins: [Mixins],
	// components: {
  //   AnimatedNumber
  // },
	data () {
		return {
			tmpMenuId: this.menudetail.id,
			tmpTotalPrice: (this.flag === 'addCart') ? Number(this.menudetail.price) : Number(this.menudetail.subtotal),
			activeTotalPrice: false,
			num: (this.flag === 'addCart') ? 1 : this.menudetail.qty,
			subtotal: (this.flag === 'addCart') ? Number(this.menudetail.price) : Number(this.menudetail.subtotal),
			currency: this.$store.getters.currency
		}
	},
	mounted () {
		this.tmpMenuId = this.menudetail.id
		if (this.flag === 'addCart') {
			// action: add cart fristime set unactive total price blue color
			this.activeTotalPrice = false
			// set tmp total price
			this.tmpTotalPrice = this.subtotal

			this.$emit('toggle_total_price', { price: this.subtotal, loading: this.activeTotalPrice, action: 'addCart' })
			this.$store.dispatch('resetIncrItem', 1)
		} else {
			// action: edit cart fristime set active total price blue color
			this.activeTotalPrice = (Number(this.menudetail.price) == this.subtotal) ? false : true
			// set tmp total price
			this.tmpTotalPrice = Number(this.menudetail.price)

			this.$emit('toggle_total_price', { price: this.subtotal, loading: this.activeTotalPrice, action: 'editCart' })
			this.$store.dispatch('resetIncrItem', this.menudetail.qty)
		}
	},
	methods: {
		formatToPrice (value) {
      return `${this.$t('pageMenuDetail.price')} <span>${ this.price_format(value,this.currency) }</span>`;
    },
		IncreaseToCart () {
			this.$store.dispatch('IcrQtyToCart', {
				branchdetail: this.BranchDetail,
				menu: this.menudetail,
				options: this.options,
				notaion: this.notaion,
				flag: this.flag
			})
		},
		DecreaseToCart () {
			if (this.num > 1) {
				this.$store.dispatch('DcrQtyToCart', {
					branchdetail: this.BranchDetail,
					menu: this.menudetail,
					options: this.options,
					notaion: this.notaion,
					flag: this.flag
				})
			}
		}
	},
	computed: {
		cart () {
			return this.$store.getters.cart
		},
		BranchDetail () {
			return this.$store.getters.BranchDetail
		}
	},
	watch: {
		BranchDetail () {},
		flag (value) {
			if (value == 'addCart') {
				this.tmpTotalPrice = this.subtotal
				this.$emit('toggle_total_price', { price: this.subtotal, loading: this.activeTotalPrice, action: 'addCart' })
			} else {
				this.activeTotalPrice = (Number(this.menudetail.price) == this.subtotal) ? false : true
				this.tmpTotalPrice = Number(this.menudetail.price)
				this.$emit('toggle_total_price', { price: this.subtotal, loading: this.activeTotalPrice, action: 'editCart' })
			}
		},
		subtotal (value) {
			if (this.flag == 'addCart') {
				if (this.tmpTotalPrice == value || isNaN(this.tmpTotalPrice) ||
					this.tmpTotalPrice == 0 || this.tmpMenuId != this.menudetail.id) { // detect change menu id
						this.tmpTotalPrice = value // set tmp total price
						this.tmpMenuId = this.menudetail.id // set menu id when change menu
						this.activeTotalPrice = false // unactive total price blue color
				} else {
					this.activeTotalPrice = true // active total price blue color
				}
				this.$emit('toggle_total_price', { price: value, loading: this.activeTotalPrice, action: 'addCart' })
			} else {
				if (this.tmpTotalPrice == value || this.tmpTotalPrice == 0) {
					this.tmpTotalPrice = value
					this.activeTotalPrice = false
				} else {
					this.activeTotalPrice = true
				}
				this.$emit('toggle_total_price', { price: value, loading: this.activeTotalPrice, action: 'editCart' })
			}
		},
		cart (value) {
			if (value.length > 0) {
				let index = value.findIndex( element => element.id === this.menudetail.id)
				this.num = (typeof value[index].qty === 'undefined') ? 1 : value[index].qty,
				this.subtotal = (typeof value[index].subtotal === 'undefined') ? 1 : value[index].subtotal
			}
		},
		menudetail (value) {
			this.num = (typeof value.qty === 'undefined') ? 1 : value.qty,
			this.subtotal = (typeof value.subtotal === 'undefined') ? Number(this.menudetail.price) : Number(value.subtotal)
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/element/elementMenuDetail.vue